module.exports = __webpack_public_path__ + "img/terentos.1a4c5030.jpg";